import {MenuItem} from './MenuItem'
import {useLocation, Link, useParams} from 'react-router-dom'
import {
  FindBrandnameByCode,
  FindOrgNameByCode,
  FindOrgPrefColorByCode,
  FindOrgPodLogoByCode,
} from '../../../../../app/modules/FindPodIdByPodCode'
import {useAuth} from '../../../../../app/modules/auth'
import {KTIcon} from '../../../../helpers'
import clsx from 'clsx'
import {PodSelectModal} from '../PodsModal'
import Tippy from '@tippyjs/react'
import {useThemeMode} from '../../../../partials'

export function MenuInner() {
  const {mode} = useThemeMode()
  const {id} = useParams()
  const {pathname} = useLocation()
  const brandName = FindBrandnameByCode()
  const orgName = FindOrgNameByCode()
  const prefColor = FindOrgPrefColorByCode()
  const podLogo = FindOrgPodLogoByCode()

  const name = encodeURIComponent(brandName)
  const {currentUser} = useAuth()

  function getWishesMessage() {
    const now = new Date()
    const hours = now.getHours()

    if (hours < 12) {
      return 'Good Morning'
    } else if (hours < 18) {
      return 'Good Afternoon'
    } else {
      return 'Good Evening'
    }
  }

  const wishMsg = getWishesMessage()
  const itemClass = 'me-1 me-lg-3'

  if (
    pathname === '/my-pods' ||
    pathname === '/my-invites' ||
    pathname === '/my-profile' ||
    pathname === '/pending-requests'
  ) {
    return (
      <div className='h-100 d-flex justify-content-between align-items-center py-5 w-100'>
        <div className='d-none d-lg-block app-navbar flex-shrink-0'>
          <div className={clsx('app-navbar-item', itemClass)}>
            <PodSelectModal />
          </div>
        </div>
        <h3 className='fs-3 fw-semibold m-auto'>
          {wishMsg}, <span className='text-primary'>{currentUser?.first_name || ''}</span>
        </h3>
      </div>
    )
  }

  return (
    <div className='h-100 d-flex justify-content-between align-items-center py-5 w-100'>
      <div className='d-none d-lg-block app-navbar flex-shrink-0'>
        <div className={clsx('app-navbar-item', itemClass)}>
          <PodSelectModal />
        </div>
      </div>
      {/* Left: Logo + Org Info */}
      <div className='d-flex align-items-center'>
        <div className='symbol symbol-50px me-3'>
          <img
            style={{height: 'auto', maxWidth: '40px', borderRadius: '3px'}}
            src={
              podLogo?.url
                ? podLogo?.url
                : `${process.env.REACT_APP_API_BASE_URL}/get/profile?name=${name}&color=${
                    prefColor ? prefColor.substring(1) : ''
                  }&size=128`
            }
            alt='logo'
          />
        </div>
        <div>
          <h6 className='fw-semibold mb-0'>{orgName}</h6>
          <p className='fw-normal text-muted fs-7 mb-0'>{brandName}</p>
        </div>
      </div>

      {/* Right: Plan Name Button */}
      <Tippy content='Manage your subscription plan'>
        <Link
          to={`/${id}/manage-subscriptions`}
          // className='btn btn-sm btn-light-primary border border-primary fw-semibold px-3 py-1 fs-8 ms-2 d-flex align-items-center text-primary text-hover-light'
          className={`btn btn-sm bg-${
            mode === 'dark' ? 'secondary' : 'white'
          } btn-outline border-primary text-primary btn-active-light-primary d-flex align-items-center ms-2`}
        >
          {/* Show text on sm+ devices */}
          <span className='d-none d-sm-inline'>Upgrade Plan</span>
          {/* Show icon on xs devices */}
          {/* <i className='bi bi-arrow-up-circle d-inline d-sm-none fs-6'></i> */}
        </Link>
      </Tippy>
    </div>
  )
}
